const defaultScreenOptions = {
    animationEnabled: false,
} as const;

export {
    // eslint-disable-next-line import/prefer-default-export
    defaultScreenOptions,
};
